import ModelService from './model.service';

const LicenseService = new ModelService('/licenses', '/licenses', 'licenses');

LicenseService.TYPE_PREMIUM = 1;
LicenseService.TYPE_BASIC = 2;
LicenseService.TYPE_TOKEN = 3;

LicenseService.getTypesList = t => ({
  [LicenseService.TYPE_PREMIUM]: t('PREMIUM'),
  [LicenseService.TYPE_BASIC]: t('BASIC'),
  [LicenseService.TYPE_TOKEN]: t('TOKEN'),
});

LicenseService.getColorByType = (type) => {
  switch (type) {
    case LicenseService.TYPE_PREMIUM:
      return 'danger';
    case LicenseService.TYPE_BASIC:
      return 'info';
    case LicenseService.TYPE_TOKEN:
      return 'success';
    default:
      return 'secondary';
  }
};

LicenseService.getTypesOptions = t => LicenseService
  .prepareOptionsFromSimpleObject(LicenseService.getTypesList(t));

LicenseService.getTypeTitle = (status, t) => {
  const label = LicenseService.getTypesList(t)[status];
  return label || '-';
};

LicenseService.STATUS_INACTIVE = 0;
LicenseService.STATUS_UNLIMITED = 1;
LicenseService.STATUS_TOKEN_UNLIMITED = 2;
LicenseService.STATUS_TOKEN_LIMITED = 3;

LicenseService.getStatusesList = t => ({
  [LicenseService.STATUS_INACTIVE]: t('INACTIVE'),
  [LicenseService.STATUS_UNLIMITED]: t('UNLIMITED'),
  [LicenseService.STATUS_TOKEN_UNLIMITED]: t('TOKEN UNLIMITED'),
  [LicenseService.STATUS_TOKEN_LIMITED]: t('TOKEN LIMITED'),
});

LicenseService.getStatusesOptions = t => LicenseService
  .prepareOptionsFromSimpleObject(LicenseService.getStatusesList(t));

LicenseService.getStatusTitle = (status, t) => {
  const label = LicenseService.getStatusesList(t)[status];
  return label || '-';
};

LicenseService.getColorByStatus = (status) => {
  switch (status) {
    case LicenseService.STATUS_INACTIVE:
      return 'danger';
    case LicenseService.STATUS_UNLIMITED:
      return 'success';
    case LicenseService.STATUS_TOKEN_UNLIMITED:
      return 'primary';
    case LicenseService.STATUS_TOKEN_LIMITED:
      return 'info';
    default:
      return 'secondary';
  }
};

export default LicenseService;



// WEBPACK FOOTER //
// ./src/services/license.service.js